export interface ThemeObj {
  name?: string;
  description?: string;
  auth_theme?: boolean;
  theme_type?: string;
  sidebar_blur?: string;
  sidebar_alpha?: number;
  page_item_alpha?: number;
  event_background?: string;
  name_card_radius?: string;
  splash_page_hero?: string;
  stage_background?: string;
  stage_text_color?: string;
  splash_text_color?: string;
  primary_text_color?: string;
  splash_shade_alpha?: string;
  theme_primary_color?: string;
  ctrl_bar_shade_alpha?: number;
  name_card_background?: string;
  name_card_text_color?: string;
  secondary_text_color?: string;
  p2p_panel_shade_alpha?: number;
  theme_secondary_color?: string;
  lower_third_background?: string;
  lower_third_text_color?: string;
  splash_gradient_height?: string;
  mobile_event_background?: string;
  mobile_splash_page_hero?: string;
  mobile_stage_background?: string;
  name_card_title_display?: string;
  screen_saver_background?: string;
  screen_saver_text_color?: string;
  splash_background_color?: string;
  splash_background_shade?: string;
  primary_background_shade?: string;
  splash_text_onimage_color?: string;
  alt_primary_background_shade?: string;
}

export interface EventBrandingObj {
  favicon?: string;
  logo_url?: string;
  social_media_thumbnail?: string;
}

export interface GeneratedTheme {
  theme_obj: ThemeObj;
  event_branding_obj: EventBrandingObj;
  name: string;
  description: string;
}

export enum DemoRequestSubmitType {
  ONE_CLICK = 'ONE_CLICK',
  TWO_STEP = 'TWO_STEP'
}

export interface MergedTheme extends ThemeObj, EventBrandingObj {}
